import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { TagProps } from './Tag.types';
import './Tag.scss';

const b = cn('tag');

export const Tag = ({ text, link }: TagProps) => {
    const className = b({ clickable: Boolean(link) });

    if (link) {
        return (
            <Link to={link} className={className}>
                {text}
            </Link>
        );
    }

    return <span className={className}>{text}</span>;
};
